export default "__VITE_ASSET__kDk3VrMC__"